import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { FormSpecialDiscount } from './FormSpecialDiscount';
import { AuthorizedSpecialDiscount } from './AuthorizedSpecialDiscount';
import { DeleteSpecialDiscount } from './DeleteSpecialDiscount';
import { Dialog } from "primereact/dialog";

export const ModalSpecialDiscount = (props) => {

    const {
        modalSpecialDiscount, closeDialogSpecialDiscount, methodSpecialDiscount, modalTitle,
        loading, percentage, percentage_global, listExams, listProfiles, listSelectedExams, listSelectedProfiles,
        idSpecialDiscount, id_exam_include, id_profile_include,
        handleInputChange, handleChangeTypeDiscount, handleExamsIncludes, handleProfileIncludes, handleInputPercentageIndividual,
        validationsSpecialDiscount,
        saveCreate, handleRemoveTest,
        saveAuthorized, saveUpdate, saveDelete, handleSearchChange
    } = props;

    return (
        <Dialog header={modalTitle} visible={modalSpecialDiscount} onHide={closeDialogSpecialDiscount} closable={true} modal blockScroll     className={methodSpecialDiscount === "auth" ? "medium-dialog" : "large-dialog"}
>
           
            {
                (methodSpecialDiscount === "create" || methodSpecialDiscount === "view" || methodSpecialDiscount === "update")
                ?
                    <FormSpecialDiscount
                        readOnly={methodSpecialDiscount === "view" ? true : false }
                        button="Crear descuento especial"
                        methodAction={methodSpecialDiscount === "create" ? saveCreate : saveUpdate}
                        {
                            ...{
                                closeDialogSpecialDiscount, loading, 
                                handleInputChange, handleChangeTypeDiscount, percentage, percentage_global, 
                                id_exam_include, id_profile_include,
                                listExams, listProfiles, listSelectedExams, listSelectedProfiles, handleInputPercentageIndividual,
                                handleExamsIncludes, handleProfileIncludes,
                                validationsSpecialDiscount, 
                                handleRemoveTest, handleSearchChange                       
                            }
                        }
                    />
                : 
                    (methodSpecialDiscount === "auth")
                    ?
                        <AuthorizedSpecialDiscount
                            {...{ toggle:closeDialogSpecialDiscount, loading, saveAuthorized, idSpecialDiscount }}
                        />
                    : 
                    
                    (methodSpecialDiscount === "delete")
                    ?
                        <DeleteSpecialDiscount
                            {
                                ...{
                                    toggle: closeDialogSpecialDiscount, loading, saveDelete, idSpecialDiscount
                                }
                            }
                        />
                    : ""
            }
        </Dialog>
    )
}
